(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["np-categories"] && !Shopify.designMode) return;
  try {
    
(function () {
  function randomIndex(max) {
    if (window.crypto && window.crypto.getRandomValues) {
      var values = new Uint32Array(1);
      window.crypto.getRandomValues(values);
      return values[0] % max;
    }
    return Math.floor(Math.random() * max);
  }

  function shuffle(items) {
    var shuffled = items.slice();
    for (var i = shuffled.length - 1; i > 0; i -= 1) {
      var j = randomIndex(i + 1);
      var temp = shuffled[i];
      shuffled[i] = shuffled[j];
      shuffled[j] = temp;
    }
    return shuffled;
  }

  function initCategories(scope) {
    var root = scope || document;
    var grids = root.querySelectorAll('[data-np-category-grid]');

    grids.forEach(function (grid) {
      if (grid.dataset.npRandomized === 'true') return;

      var items = Array.from(grid.querySelectorAll('[data-np-category]'));
      var visibleCount = Math.min(parseInt(grid.dataset.visibleCount || '6', 10), items.length);
      var storageKey = grid.dataset.storageKey || 'np-categories';
      var previousSelection = '';

      try {
        previousSelection = sessionStorage.getItem(storageKey) || '';
      } catch (error) {
        previousSelection = '';
      }

      var shuffled = shuffle(items);
      var selectionKey = shuffled
        .slice(0, visibleCount)
        .map(function (item) {
          return item.dataset.categoryHandle || '';
        })
        .sort()
        .join('|');

      var attempts = 0;
      while (selectionKey === previousSelection && attempts < 10 && items.length > visibleCount) {
        shuffled = shuffle(items);
        selectionKey = shuffled
          .slice(0, visibleCount)
          .map(function (item) {
            return item.dataset.categoryHandle || '';
          })
          .sort()
          .join('|');
        attempts += 1;
      }

      shuffled.forEach(function (item, index) {
        item.style.display = index < visibleCount ? '' : 'none';
        grid.appendChild(item);
      });

      try {
        sessionStorage.setItem(storageKey, selectionKey);
      } catch (error) {
      }

      grid.dataset.npRandomized = 'true';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCategories(document);
    });
  } else {
    initCategories(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initCategories(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["np-featured-products"] && !Shopify.designMode) return;
  try {
    
(function () {
  function randomIndex(max) {
    if (window.crypto && window.crypto.getRandomValues) {
      var values = new Uint32Array(1);
      window.crypto.getRandomValues(values);
      return values[0] % max;
    }
    return Math.floor(Math.random() * max);
  }

  function shuffle(items) {
    var result = items.slice();
    for (var i = result.length - 1; i > 0; i -= 1) {
      var j = randomIndex(i + 1);
      var temp = result[i];
      result[i] = result[j];
      result[j] = temp;
    }
    return result;
  }

  function selectionKey(items) {
    return items
      .map(function (item) {
        return item.dataset.productHandle || '';
      })
      .sort()
      .join('|');
  }

  function percentile(values, fraction) {
    if (!values.length) return 0;
    values.sort(function (a, b) {
      return a - b;
    });
    var index = Math.floor((values.length - 1) * fraction);
    return values[index];
  }

  function detectPortrait(url) {
    return new Promise(function (resolve) {
      if (!url) {
        resolve(false);
        return;
      }

      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.decoding = 'async';

      img.onload = function () {
        try {
          var size = 120;
          var canvas = document.createElement('canvas');
          canvas.width = size;
          canvas.height = size;
          var ctx = canvas.getContext('2d', { willReadFrequently: true });

          if (!ctx) {
            resolve(false);
            return;
          }

          ctx.drawImage(img, 0, 0, size, size);
          var pixels = ctx.getImageData(0, 0, size, size).data;
          var corner = 8;
          var cornerPixels = [];

          function collectCorner(startX, startY) {
            for (var y = startY; y < startY + corner; y += 1) {
              for (var x = startX; x < startX + corner; x += 1) {
                var index = (y * size + x) * 4;
                cornerPixels.push([
                  pixels[index],
                  pixels[index + 1],
                  pixels[index + 2]
                ]);
              }
            }
          }

          collectCorner(0, 0);
          collectCorner(size - corner, 0);
          collectCorner(0, size - corner);
          collectCorner(size - corner, size - corner);

          var bgR = 0;
          var bgG = 0;
          var bgB = 0;

          cornerPixels.forEach(function (pixel) {
            bgR += pixel[0];
            bgG += pixel[1];
            bgB += pixel[2];
          });

          bgR /= cornerPixels.length;
          bgG /= cornerPixels.length;
          bgB /= cornerPixels.length;

          var xs = [];
          var ys = [];
          var threshold = 26;

          for (var py = 0; py < size; py += 1) {
            for (var px = 0; px < size; px += 1) {
              var offset = (py * size + px) * 4;
              var dr = pixels[offset] - bgR;
              var dg = pixels[offset + 1] - bgG;
              var db = pixels[offset + 2] - bgB;
              var distance = Math.sqrt((dr * dr) + (dg * dg) + (db * db));

              if (distance > threshold) {
                xs.push(px);
                ys.push(py);
              }
            }
          }

          if (xs.length < 250) {
            resolve(false);
            return;
          }

          var left = percentile(xs.slice(), 0.02);
          var right = percentile(xs.slice(), 0.98);
          var top = percentile(ys.slice(), 0.02);
          var bottom = percentile(ys.slice(), 0.98);
          var width = Math.max(1, right - left);
          var height = Math.max(1, bottom - top);
          var ratio = height / width;

          resolve(ratio >= 1.10);
        } catch (error) {
          resolve(false);
        }
      };

      img.onerror = function () {
        resolve(false);
      };

      img.src = url;
    });
  }

  async function initGrid(grid) {
    if (grid.dataset.npRandomized === 'true') return;

    var visibleCount = parseInt(grid.dataset.visibleCount || '6', 10);
    var rejectHandles = (grid.dataset.landscapeRejects || '')
      .split(',')
      .filter(Boolean);

    var allItems = Array.from(grid.querySelectorAll('[data-np-featured-product]'));
    var seenHandles = {};
    var items = allItems.filter(function (item) {
      var handle = item.dataset.productHandle || '';
      if (!handle || seenHandles[handle]) return false;
      seenHandles[handle] = true;
      return rejectHandles.indexOf(handle) === -1;
    });

    var checks = items.map(async function (item) {
      if (item.dataset.forcePortrait === 'true') return item;
      var portrait = await detectPortrait(item.dataset.detectSrc || '');
      return portrait ? item : null;
    });

    var checked = await Promise.all(checks);
    var portraitItems = checked.filter(Boolean);

    if (!portraitItems.length) {
      portraitItems = items.filter(function (item) {
        return item.dataset.forcePortrait === 'true';
      });
    }

    var count = Math.min(visibleCount, portraitItems.length);
    var storageKey = grid.dataset.storageKey || 'np-featured-products';
    var previous = '';

    try {
      previous = sessionStorage.getItem(storageKey) || '';
    } catch (error) {
      previous = '';
    }

    var shuffled = shuffle(portraitItems);
    var selected = shuffled.slice(0, count);
    var current = selectionKey(selected);
    var attempts = 0;

    while (
      current === previous &&
      attempts < 10 &&
      portraitItems.length > count
    ) {
      shuffled = shuffle(portraitItems);
      selected = shuffled.slice(0, count);
      current = selectionKey(selected);
      attempts += 1;
    }

    allItems.forEach(function (item) {
      item.style.display = 'none';
    });

    selected.forEach(function (item) {
      item.style.display = '';
      grid.appendChild(item);
    });

    try {
      sessionStorage.setItem(storageKey, current);
    } catch (error) {
    }

    grid.dataset.npRandomized = 'true';
  }

  function initFeatured(scope) {
    var root = scope || document;
    var grids = root.querySelectorAll('[data-np-featured-grid]');
    grids.forEach(function (grid) {
      initGrid(grid);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initFeatured(document);
    });
  } else {
    initFeatured(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initFeatured(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["np-hero"] && !Shopify.designMode) return;
  try {
    
class NpRandomInterior extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    this.options = Array.from(this.querySelectorAll('template[data-np-interior-id]'));
    this.rotate();
    window.addEventListener('pageshow', event => {
      if (event.persisted) this.rotate();
    }, { signal: this.controller.signal });
  }
  disconnectedCallback() {
    this.controller?.abort();
    this.controller = null;
  }
  rotate() {
    const display = this.querySelector('[data-np-interior-display]');
    if (!display || !this.options?.length) return;
    const ids = this.options.map(option => option.dataset.npInteriorId);
    let state = { seen: [], last: this.last || '' };
    try {
      const saved = JSON.parse(localStorage.getItem(this.dataset.storageKey) || 'null');
      if (saved && Array.isArray(saved.seen)) state = saved;
    } catch {}
    let choices = ids.filter(id => !state.seen.includes(id) && id !== state.last);
    if (!choices.length) {
      state.seen = [];
      choices = ids.filter(id => id !== state.last);
    }
    if (!choices.length) choices = ids;
    const selected = choices[Math.floor(Math.random() * choices.length)];
    const template = this.options.find(option => option.dataset.npInteriorId === selected);
    display.replaceChildren(template.content.cloneNode(true));
    this.last = selected;
    this.dataset.selectedImage = selected;
    try {
      localStorage.setItem(this.dataset.storageKey, JSON.stringify({ seen: [...state.seen, selected], last: selected }));
    } catch {}
  }
}
if (!customElements.get('np-random-interior')) customElements.define('np-random-interior', NpRandomInterior);

  } catch(e) { console.error(e); }
})();
})();
